import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'FordAntenna';
    src: url('https://www.ford.eu/static/prod/fonts/antenna/ford-antenna-light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FordAntenna';
    src: url('https://www.ford.eu/static/prod/fonts/antenna/ford-antenna-regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FordAntenna';
    src: url('https://www.ford.eu/static/prod/fonts/antenna/ford-antenna-semibold.woff2') format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FordAntenna';
    src: url('https://www.ford.eu/static/prod/fonts/antenna/ford-antenna-bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    font-family: 'FordAntenna', sans-serif !important;
  }

  #root {
    margin: 0;
    padding: 0;
    min-height: 100vh;
  }

  html {
    margin: 0;
    padding: 0;
  }

  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    @media (min-width: 1024px) {
      width: 100%;
    }
  }

  p {
    text-align: justify;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  :root {
    /* Primary Colors */
    --color-navy: #00142e;
    --color-navy-header: #00095b;
    --color-blue-active: #1700f4;
    --color-link-blue: #0056b3;

    /* Text Colors */
    --color-text-body: #00095b;
    --color-text-muted: #aaa;
    --color-text-subtle: #666;
    --color-text-on-dark: rgba(255, 255, 255, 0.85);
    --color-link-on-dark: #93c5fd;
    --color-white: #ffffff;
    --color-white-muted: rgba(255, 255, 255, 0.4);

    /* Background Colors */
    --bg-section: #ebebf5;
    --bg-blue-soft: #e8f1f8;
    --bg-map: #f5f5f5;

    /* Border Colors */
    --border-gray: #E0E0E0;
    --border-image: #878a92;
    --border-blue-gray: #dde3ea;
    --border-blue-light: #d0dce6;
    --border-map: #d0d0d0;
  }

  h1, h2, h3, h4, h5, h6, p, span, label, li {
    margin: 0;
    padding: 0;
    color: var(--color-text-body) !important;
  }

  h2 {
    font-weight: 600 !important;
  }

  main a {
    text-decoration: underline !important;
    color: var(--color-blue-active) !important;

    &:hover {
      color: var(--color-navy-header) !important;
    }
  }
`;

export default GlobalStyle;
